import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Container, Row, Col, Nav, NavItem, NavLink, Card, CardBody, CardHeader } from 'reactstrap';
import { createHashHistory } from 'history';
import { Prompt } from 'react-router-dom';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import FormModal from '../forms/formModal';
import SectionPanel from '../common/containers/sectionPanel';
import routeHelper from '../common/classes/routeHelper';
import RejectionNoteModal from './rejectionNoteModal';
import ReportIssueSummary from './reportIssueSummary';
// import logger from '../../utils/logger';
import Loader from '../common/loader';
import EditorComponent from '../editor/editorComponent';
const hashHistory = createHashHistory();
export const getLatestStatus = report => {
  if (!report || !report.active || !report.active.content) {
    return null;
  }
  const statusHistory = report.active.content.statusHistory;
  if (!statusHistory) {
    return null;
  }
  let newestStatus = null;
  Object.keys(statusHistory).forEach(key => {
    const status = statusHistory[key];
    /* eslint-disable no-underscore-dangle */
    if (!newestStatus || new Date(status._created) > new Date(newestStatus._created)) {
      newestStatus = status;
    }
    /* eslint-enable no-underscore-dangle */
  });
  return newestStatus;
};
class ReportEditor extends Component {
  constructor(props) {
    if (!props.match.params || !props.match.params.id) {
      throw new Error('props.match.params.id is required');
    }
    super(props);

    /* eslint-disable-next-line react/no-unused-class-component-methods */
    this.format = {};
    this.state = {
      loaded: true,
      // track initial loading to avoid Loader usage on saves
      sectionIndex: null,
      rejectionNoteModal: {
        active: false,
        note: null,
        open: false,
        acknowledged: false
      }
    };
    this.getSectionIndex = this.getSectionIndex.bind(this);
    this.getSections = this.getSections.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleSelectSection = this.handleSelectSection.bind(this);
    this.toggleRejectionModal = this.toggleRejectionModal.bind(this);
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    const id = nextProps.match.params.id,
      _nextProps$report = nextProps.report,
      activeID = _nextProps$report.active.id,
      loading = _nextProps$report.loading,
      newReportID = _nextProps$report.newReportID;
    let newState = null;
    if (prevState.loaded && loading && id !== activeID) {
      // display the Loader
      newState = _objectSpread(_objectSpread({}, newState), {}, {
        loaded: false
      });
    } else if (!prevState.loaded && !loading) {
      // hide the Loader
      newState = _objectSpread(_objectSpread({}, newState), {}, {
        loaded: true
      });
    }

    // If new report id is set, ignore checking for rejections
    if (!newReportID) {
      const reportStatus = getLatestStatus(nextProps.report);
      if (reportStatus && reportStatus.identifier && reportStatus.identifier === 'rejected' && reportStatus.note !== '' && !prevState.rejectionNoteModal.acknowledged) {
        newState = _objectSpread(_objectSpread({}, newState), {}, {
          rejectionNoteModal: {
            active: true,
            note: reportStatus.note,
            open: true
          }
        });
      }
    }
    return newState;
  }
  componentDidMount() {
    const _this$props = this.props,
      id = _this$props.match.params.id,
      reportActions = _this$props.reportActions;
    reportActions.serverShow(id);
  }
  componentWillUnmount() {
    const reportActions = this.props.reportActions;
    reportActions.showCancel();
  }
  getSectionFormat() {
    const sectionKey = this.getSectionIndex();
    const sections = this.getSections();
    const section = sections.find(currentSection => currentSection.label === sectionKey);
    return section ? section.format : undefined;
  }
  getSectionIndex() {
    const params = this.props.match.params;
    const sectionIndex = this.state.sectionIndex;

    // return the first section.
    const sections = this.getSections();
    if (sectionIndex) {
      if (sections.some(next => next.label === sectionIndex)) {
        return sectionIndex;
      }
    }
    if (params.section) {
      let sectionToLoad;
      sections.forEach(next => {
        if (kebabCase(next.label) === kebabCase(params.section)) {
          sectionToLoad = next.label;
        }
      });
      if (sectionToLoad) {
        return sectionToLoad;
      }
    }
    if (sections && sections.length > 0) {
      return sections[0].label;
    }

    // what should we return as default?
    return 'General';
  }
  getSections() {
    const _this$props$report$ac = this.props.report.active.format,
      format = _this$props$report$ac === void 0 ? {} : _this$props$report$ac;
    if (format && format.children) {
      return format.children.map(child => ({
        label: child.label,
        format: child
      }));
    }
    return [];
  }
  redirectUser() {
    const _this$props2 = this.props,
      pathname = _this$props2.location.pathname,
      notificationActions = _this$props2.notificationActions;
    notificationActions.error({
      message: "You are not authorized to access ".concat(this.getPathname ? pathname : 'this resource.')
    });
    hashHistory.replace('/accessDenied');
  }
  handleBack() {
    const id = this.props.report.active.id;
    if (id === undefined) {
      return;
    }
    routeHelper.updateURL("/reports/".concat(id));
  }
  async handleChange(_ref) {
    let path = _ref.path,
      value = _ref.value,
      _ref$changeModifiers = _ref.changeModifiers,
      changeModifiers = _ref$changeModifiers === void 0 ? {} : _ref$changeModifiers;
    const _this$props3 = this.props,
      reportActions = _this$props3.reportActions,
      id = _this$props3.match.params.id;
    const contentPath = "content/".concat(path);
    // create a change action with the new info.
    // need to prepend the content object to this keypath
    return reportActions.change(id, contentPath, value, changeModifiers);
  }
  async handleSave() {
    const _this$props4 = this.props,
      serverSave = _this$props4.reportActions.serverSave,
      active = _this$props4.report.active;
    const version = active && active.content && active.content.version || undefined;
    // used in the routeHeloper transitionAsync method as well as section panel onSave
    serverSave(version);
  }
  handleSelectSection(sectionkey) {
    this.setState({
      sectionIndex: sectionkey
    });
  }
  toggleRejectionModal() {
    const open = this.state.rejectionNoteModal.open;
    this.setState({
      rejectionNoteModal: {
        open: !open,
        acknowledged: true
      }
    });
  }
  render() {
    const _this$props5 = this.props,
      _this$props5$report = _this$props5.report,
      pendingChanges = _this$props5$report.pendingChanges,
      loading = _this$props5$report.loading,
      active = _this$props5$report.active,
      canEdit = _this$props5.canEdit,
      _this$props5$reportAc = _this$props5.reportActions,
      operationComplete = _this$props5$reportAc.operationComplete,
      operationPending = _this$props5$reportAc.operationPending;
    const _this$state = this.state,
      loaded = _this$state.loaded,
      rejectionNoteModal = _this$state.rejectionNoteModal;

    // Check if user authenticated first
    if (active && active.content && !canEdit) {
      this.redirectUser();
    }
    const isReportLoaded = active && active.id;
    const content = active && active.content ? active.content : null;
    const _active$content = active.content,
      _active$content2 = _active$content === void 0 ? {} : _active$content,
      _active$content2$repo = _active$content2.reportType,
      _active$content2$repo2 = _active$content2$repo === void 0 ? {} : _active$content2$repo,
      reportTypeName = _active$content2$repo2.name,
      _active$reportNumber = active.reportNumber,
      reportNumber = _active$reportNumber === void 0 ? {} : _active$reportNumber;
    const sectionIndex = this.getSectionIndex();
    const sectionFormat = this.getSectionFormat();
    const sections = this.getSections();
    let hasSection = false;
    if (sectionFormat && sectionFormat.children) {
      hasSection = true;
    }
    let sectionKeyPath = '/';
    if (sectionFormat && sectionFormat.contentPath) {
      sectionKeyPath = sectionFormat.contentPath.substring(0, 1) === '/' ? sectionFormat.contentPath : "/".concat(sectionFormat.contentPath); // prepend path with '/' if contentPath exists
    }
    let reportTitle = '';
    if (content && reportTypeName && reportNumber) {
      reportTitle = "".concat(reportTypeName, " ").concat(reportNumber);
    }
    return /*#__PURE__*/React.createElement(Loader, {
      top: "50%",
      loaded: loaded
    }, /*#__PURE__*/React.createElement(Container, {
      className: "ReportEditor"
    }, /*#__PURE__*/React.createElement(Prompt, {
      when: pendingChanges,
      message: location => routeHelper.transitionAsync(this, 'report', location)
    }), rejectionNoteModal.active && /*#__PURE__*/React.createElement(RejectionNoteModal, {
      isOpen: rejectionNoteModal.open,
      onHide: this.toggleRejectionModal,
      rejectionNote: rejectionNoteModal.note
    }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
      className: "card-heading"
    }, /*#__PURE__*/React.createElement("h3", null, "Report Sections")), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Nav, {
      vertical: true,
      pills: true
    }, sections.map(section => /*#__PURE__*/React.createElement(NavItem, {
      style: {
        maxWidth: '100%'
      },
      className: "t-re-nav-section-".concat(kebabCase(section.label), " report-nav-item"),
      active: sectionIndex === section.label,
      key: "NAV_".concat(section.label.replace(/[\s-]/g, ''))
    }, /*#__PURE__*/React.createElement(NavLink, {
      onClick: () => this.handleSelectSection(section.label)
    }, section.label)))))), /*#__PURE__*/React.createElement(ReportIssueSummary, {
      noURL: true,
      report: active
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 9
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SectionPanel, {
      isPending: pendingChanges,
      isSaveDisabled: loading,
      onBack: this.handleBack,
      backButtonTitle: isReportLoaded ? 'View Report PDF' : 'Loading...',
      onSave: this.handleSave,
      name: reportTitle,
      showTagButton: true
    }, hasSection ? /*#__PURE__*/React.createElement(EditorComponent, {
      path: sectionKeyPath,
      format: sectionFormat,
      onChange: this.handleChange,
      reduxEntity: "report",
      operationComplete: operationComplete,
      operationPending: operationPending
    }) : /*#__PURE__*/React.createElement("div", {
      style: {
        minHeight: '300px'
      }
    }, active && !loading && /*#__PURE__*/React.createElement("p", {
      "data-testid": "t-re-no-section"
    }, "This section", /*#__PURE__*/React.createElement("strong", null, "\xA0", sectionFormat && sectionFormat.label ? sectionFormat.label : '', "\xA0"), "is not defined in the editor."))))))), /*#__PURE__*/React.createElement(FormModal, null));
  }
}
ReportEditor.propTypes = {
  canEdit: PropTypes.bool.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
      section: PropTypes.string
    }).isRequired
  }).isRequired,
  report: PropTypes.shape({
    activeCache: PropTypes.shape({
      staticContent: PropTypes.shape({})
    }),
    active: PropTypes.shape({
      content: PropTypes.shape({
        reportType: PropTypes.shape({
          name: PropTypes.string
        }),
        version: PropTypes.string
      }),
      format: PropTypes.shape({}),
      ReportType: PropTypes.shape({}),
      reportNumber: PropTypes.number,
      id: PropTypes.string
    }),
    error: PropTypes.shape({
      response: PropTypes.shape({
        status: PropTypes.number
      })
    }),
    loading: PropTypes.bool,
    pendingChanges: PropTypes.bool,
    newReportID: PropTypes.string
  }).isRequired,
  user: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string
  }).isRequired,
  reportActions: PropTypes.shape({
    change: PropTypes.func,
    operationPending: PropTypes.func,
    operationComplete: PropTypes.func,
    showCancel: PropTypes.func,
    serverSave: PropTypes.func,
    serverShow: PropTypes.func,
    showSuccess: PropTypes.func
  }).isRequired,
  notificationActions: PropTypes.shape({
    error: PropTypes.func,
    info: PropTypes.func
  }).isRequired
};
export { ReportEditor as TestReportEditor };

// This entity is wrapped by "reportEditorContainer.js" which handles selectors etc.
export default ReportEditor;